import React from 'react';
import { mergeSx } from '@jucy-ui/appearance';
import { BoxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface BookingSummaryPanelSectionProps extends Omit<BoxProps, 'title'> {
    edit?: React.ReactNode;
    title?: React.ReactNode;
    gutterBottom?: boolean;
}

const BookingSummaryPanelSection: React.FC<BookingSummaryPanelSectionProps> = ({ children, className, edit, gutterBottom, sx, title, ...props }) => (
    <Box
        {...props}
        sx={mergeSx(
            {
                mb: gutterBottom ? 2 : undefined,
            },
            sx
        )}
    >
        <Box
            sx={{
                display: 'flex',
                direction: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            {title ? (
                <Typography
                    component="span"
                    variant="subtitle1"
                    sx={{
                        display: 'block',
                        fontWeight: '700',
                        textTransform: 'uppercase',
                    }}
                >
                    {title}
                </Typography>
            ) : null}
            {edit}
        </Box>
        {children}
    </Box>
);

export default BookingSummaryPanelSection;
